import { ValidationSummary } from 'devextreme-react/validation-summary';
import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import {
	ChangeOrderButton,
	CreateEstimateButton,
	ExitButton,
	PlumbingBanner,
	RequestCancellationButton,
	RetailOrderAddNoteButton,
	RetailOrderCommunicationButton,
	RetailOrderFilesButton,
	RetailOrderInformationCards,
	RetailOrderNotesPanel,
	RetailOrderPage,
	RetailOrderProducts,
	RetailOrderProgress,
	RetailOrderProgressStep,
	SaveButton,
	ScheduleDatesPanel,
	SetToPendingButton,
	ViewChangeRequestButton,
	WorksheetTemplateLink,
	WorksheetType
} from '../../../features/cfi/retail-order';
import '../../../css/order.scss';

export default function RetailOrderSchedulePage() {

	return (
		<RetailOrderPage>

			<PlumbingBanner />

			<RetailOrderInformationCards />

			<RetailOrderProgress />

			<ValidationSummary />

			<Box>
				<Item ratio={1}>
					<Toolbar className='button-toolbar' multiline={true}>
						<ToolbarItem>
							<SaveButton step={RetailOrderProgressStep.Schedule} />
						</ToolbarItem>
						<ToolbarItem>
							<RetailOrderCommunicationButton />
						</ToolbarItem>
						<ToolbarItem>
							<RetailOrderFilesButton />
						</ToolbarItem>
						<ToolbarItem>
							<SetToPendingButton />
						</ToolbarItem>
						<ToolbarItem>
							<CreateEstimateButton />
						</ToolbarItem>
						<ToolbarItem>
							<ChangeOrderButton step={RetailOrderProgressStep.Schedule} />
						</ToolbarItem>
						<ToolbarItem>
							<ViewChangeRequestButton step={RetailOrderProgressStep.Schedule} />
						</ToolbarItem>
						<ToolbarItem>
							<RequestCancellationButton />
						</ToolbarItem>
						<ToolbarItem>
							<ExitButton />
						</ToolbarItem>

					</Toolbar>
				</Item>
				<Item ratio={0} baseSize={190}>
					<Toolbar className='button-toolbar' multiline={true}>
						<ToolbarItem>
							<RetailOrderAddNoteButton showNoteType={false} changeOrder={false} />
						</ToolbarItem>
					</Toolbar>
				</Item>
			</Box>

			<Box>
				<Item ratio={1}>
					<ScheduleDatesPanel />
				</Item>
				<Item ratio={1}>
					<RetailOrderNotesPanel height={200} />
				</Item>
			</Box>

			<WorksheetTemplateLink
				worksheetType={WorksheetType.CabinetQualityCheck}
				caption="Download Cabinet Quality Check Worksheet Template"
			/>

			<RetailOrderProducts />

		</RetailOrderPage>
	)
}
